// import React, { useEffect, useState } from "react";
// import { MdClose, MdArrowBackIos } from "../utils/Icons";
// import { useAddressContext } from "../context/AddressContext";
// import { useOrderProcessingContext } from "../context/OrderProcessingContext";

// // Imports
// import CustomInput from "../components/CustomComponents/CustomInput";
// import CustomSelect from "../components/CustomComponents/CustomSelect";
// import axios from "axios";
// import { baseUrl } from "../utils/OtherUtils";

// const AddAddressPopup = ({ closeButton }) => {
//   const { addressData, addressSave, addAddress, setAddAddress } =
//     useAddressContext();
//   const { updateAddress } = useOrderProcessingContext();
//   const [isAddingAddress, setIsAddingAddress] = useState(false);
//   const [selectedCity, setSelectedCity] = useState("");
//   const [selectedState, setSelectedState] = useState("");

//   const handleStateChange = (e) => {
//     setSelectedState(e.target.value);
//     setSelectedCity("");
//   }

//   const stateCityData = {
//     "Delhi": ["New Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh"],
//     "Maharashtra": ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane"],
//     "Karnataka": ["Bengaluru", "Mysuru", "Mangalore", "Hubli", "Belgaum"],
//     "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi", "Noida", "Ghaziabad"],
//    "Rajasthan": ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer","Indore","Sagar"]
//   };

//   const handleAddingAddress = () => {
//     setIsAddingAddress((prev) => !prev);
//   };

//   const handleAddressChange = (name, value) => {
//     setAddAddress((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleRestOfAddress = (e) => {
//     const { name, value } = e.target;
//     setAddAddress((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   }

//   const handleAddressTypeSelect = (type) => {
//     setAddAddress((prevState) => ({
//       ...prevState,
//       type,
//     }));
//   };



//   useEffect(() => {
//     if (!addAddress.pincode) return;

//     const fetchPincodeData = async () => {
//       try {
//         const response = await axios.get(`${baseUrl}/api/pincode/${addAddress.pincode}`);

//         handleAddressChange('state', response.data?.PostOffice[0]?.State || '');
//         // handleAddressChange('city', response.data?.PostOffice[0]?.Taluk || '');
//         handleAddressChange('city', response.data?.PostOffice[0]?.District || '');

//       } catch (error) {
//         console.error('Error fetching pincode data:', error);
//       }
//     };

//     fetchPincodeData();
//   }, [addAddress.pincode]);

//   return (
//     <div className="w-screen h-screen bg-black/25 backdrop-blur flex justify-center items-center p-[2%] fixed left-0 top-0 right-0 bottom-0 z-50">
//       <div className="w-full lg:w-[25%] h-full lg:h-[75%] bg-whiteColor flex flex-col justify-start items-center rounded-3xl lg:rounded-3xl p-[2%] lg:p-[1%]">
//         <div className="w-full h-fit flex justify-end items-center">
//           <button
//             className="text-[5vw] lg:text-[1.25vw] text-textPrimaryColor"
//             onClick={closeButton}
//           >
//             <MdClose />
//           </button>
//         </div>
//         <span className="font-semibold text-[5vw] lg:text-[1.25vw] text-textPrimaryColor mb-[1%]">
//           Select Address
//         </span>
//         {isAddingAddress && (
//           <div className="w-full h-[79%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden  scrollbar-hide">
//             <div className="w-full h-fit space-y-[3%]">
//               <button
//                 className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
//                 onClick={handleAddingAddress}
//               >
//                 <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
//                 <span>Back</span>
//               </button>
//               <CustomInput
//                 type="text"
//                 name="house"
//                 placeholder="House No."
//                 value={addAddress.house}
//                 onChange={handleRestOfAddress}
//               />
//               <CustomInput
//                 type="text"
//                 name="area"
//                 placeholder="Area"
//                 value={addAddress.area}
//                 onChange={handleRestOfAddress}
//               />
//               <div className="w-full h-fit flex flex-col space-y-[2%]">
//                 <label
//                   htmlFor="pincode"
//                   className="font-normal text-[1vw] text-textSecondaryColor"
//                 ></label>
//                 <input
//                   type="number"
//                   id="pincode"
//                   name="pincode"
//                   placeholder="Pincode"
//                   value={addAddress.pincode}
//                   onChange={(e) => {
//                     const value = e.target.value;
//                     if (value.length <= 6) {
//                       handleRestOfAddress(e);
//                     }
//                   }}
//                   max={999999}
//                   className="input-primary"
//                 />
//               </div>
//               {/* <CustomInput
//                 type="text"
//                 name="state"
//                 placeholder="State"
//                 value={addAddress.state}
//                 onChange={handleRestOfAddress}
//               />
//               <CustomInput
//                 type="text"
//                 name="city"
//                 placeholder="City"
//                 value={addAddress.city}
//                 onChange={handleRestOfAddress}
//               /> */}

//               <select
//                 name="state"
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 // className="w-[47.5%] h-fit flex flex-col space-y-[2%] font-normal text-[1vw] text-textSecondaryColor"
//                 className="input-primary"
//               >
//                 <option value="">Select State</option>
//                 {Object.keys(stateCityData).map((state) => (
//                   <option key={state} value={state}>
//                     {state}
//                   </option>
//                 ))}
//               </select>

//               {/* City Dropdown */}
//               <select
//                 name="city"
//                 value={selectedCity}
//                 onChange={(e) => setSelectedCity(e.target.value)}
//                 // className="w-[47.5%] h-fit flex flex-col space-y-[2%] font-normal text-[1vw] text-textSecondaryColor"
//                 className="input-primary "
//                 disabled={!selectedState}
//               >
//                 <option value="">Select City</option>
//                 {selectedState &&
//                   stateCityData[selectedState].map((city) => (
//                     <option key={city} value={city}>
//                       {city}
//                     </option>
//                   ))}
//               </select>
//               <CustomSelect
//                 dataArray={["Home", "Office", "Other"]}
//                 onSelect={handleAddressTypeSelect}
//                 selectedItem={addAddress.type}

//               />
//             </div>
//           </div>
//         )}

//         {!isAddingAddress && addressData?.length > 0 && (
//           <div className="w-full h-[75%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
//             {addressData?.map((address, index) => (
//               <div
//                 className="w-full h-fit bg-white flex flex-col justify-start items-start border border-accentColor rounded-2xl p-[5%] cursor-pointer hover:border-2"
//                 key={index}
//                 onClick={() => updateAddress(address)}
//               >
//                 <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                   {address.house}, {address.area}, {address.city},{" "}
//                   {address.state} - {address.pincode}
//                 </span>
//               </div>
//             ))}
//           </div>
//         )}

//         {!isAddingAddress && addressData?.length === 0 && (
//           <div className="w-full h-[75%] flex justify-center items-center">
//             <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//               No address added yet
//             </p>
//           </div>
//         )}

//         {isAddingAddress ? (
//           <button
//             className="btn-primary"
//             onClick={() => {
//               addressSave(addAddress);
//               handleAddingAddress();
//             }}
//           >
//             Save Address
//           </button>
//         ) : (
//           <button className="btn-primary" onClick={handleAddingAddress}>
//             Add Address
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddAddressPopup;






// import React, { useState } from "react";
// import { MdClose, MdArrowBackIos, MdKeyboardArrowDown } from "../utils/Icons";
// import { useAddressContext } from "../context/AddressContext";
// import { useOrderProcessingContext } from "../context/OrderProcessingContext";

// // Imports
// import CustomInput from "../components/CustomComponents/CustomInput";
// import CustomSelect from "../components/CustomComponents/CustomSelect";

// const AddAddressPopup = ({ closeButton }) => {
//   const { addressData, addressSave, addAddress, setAddAddress } =
//     useAddressContext();
//   const { updateAddress } = useOrderProcessingContext();
//   const [isAddingAddress, setIsAddingAddress] = useState(false);
//   const [selectedCity, setSelectedCity] = useState("");
//   const [selectedState, setSelectedState] = useState("");
//   const [stateOpen, setStateOpen] = useState(false);
//   const [cityOpen, setCityOpen] = useState(false);
//   const handleStateChange = (e) => {
//     const value = e.target.value;
//     setSelectedState(value);
//     setSelectedCity("");
//     handleAddressChange("state", value);
//   };

//   const stateCityData = {
//     Delhi: ["New Delhi", "Dwarka", "Rohini", "Saket", "Karol Bagh"],
//     Maharashtra: ["Mumbai", "Pune", "Nagpur", "Nashik", "Thane", "Aizwal"],
//     Karnataka: ["Bengaluru", "Mysuru", "Mangalore", "Hubli", "Belgaum", "Bilaspur"],
//     "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi", "Noida", "Ghaziabad"],
//     Rajasthan: ["Jaipur", "Jodhpur", "Udaipur", "Kota", "Ajmer", "Indore", "Sagar"],
//   };

//   const handleAddingAddress = () => {
//     setIsAddingAddress((prev) => !prev);
//   };

//   const handleAddressChange = (name, value) => {
//     setAddAddress((prev) => ({
//       ...prev,
//       [name]: value,
//     }));
//   };

//   const handleRestOfAddress = (e) => {
//     const { name, value } = e.target;
//     handleAddressChange(name, value);
//   };

//   const handleAddressTypeSelect = (type) => {
//     handleAddressChange("type", type);
//   };

//   const handleCityChange  =(e)=>{
//     const cityValue= e.target.value;
//     setSelectedCity(cityValue);
//     setAddAddress((prev)=>({
//       ...prev, city:cityValue,
//     }))
//   }
//   return (
//     <div className="w-screen h-screen bg-black/25 backdrop-blur flex justify-center items-center p-[2%] fixed left-0 top-0 right-0 bottom-0 z-50">
//       <div className="w-full lg:w-[25%] h-full lg:h-[75%] bg-whiteColor flex flex-col justify-start items-center rounded-3xl lg:rounded-3xl p-[2%] lg:p-[1%]">
//         <div className="w-full h-fit flex justify-end items-center">
//           <button
//             className="text-[5vw] lg:text-[1.25vw] text-textPrimaryColor"
//             onClick={closeButton}
//           >
//             <MdClose />
//           </button>
//         </div>
//         <span className="font-semibold text-[5vw] lg:text-[1.25vw] text-textPrimaryColor mb-[1%]">
//           Select Address
//         </span>

//         {isAddingAddress && (
//           <div className="w-full h-[79%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden scrollbar-hide">
//             <div className="w-full h-fit space-y-[3%]">
//               <button
//                 className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
//                 onClick={handleAddingAddress}
//               >
//                 <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
//                 <span>Back</span>
//               </button>

//               <CustomInput
//                 type="text"
//                 name="house"
//                 placeholder="House No."
//                 value={addAddress.house}
//                 onChange={handleRestOfAddress}
//               />
//               <CustomInput
//                 type="text"
//                 name="area"
//                 placeholder="Area"
//                 value={addAddress.area}
//                 onChange={handleRestOfAddress}
//               />

//               {/* Normal Pincode Input */}
//               <input
//                 type="number"
//                 id="pincode"
//                 name="pincode"
//                 placeholder="Pincode"
//                 value={addAddress.pincode}
//                 onChange={(e) => {
//                   const value = e.target.value;
//                   if (value.length <= 6) {
//                     handleRestOfAddress(e);
//                   }
//                 }}
//                 max={999999}
//                 className="input-primary"
//               />

//               {/* State Dropdown */}
//               {/* <select
//                 name="state"
//                 value={selectedState}
//                 onChange={handleStateChange}
//                 className="input-primary"
//               >
//                 <option value="">Select State</option>
//                 {Object.keys(stateCityData).map((state) => (
//                   <option key={state} value={state}>
//                     {state}
//                   </option>
//                 ))}
//               </select> */}

//               {/* City Dropdown */}
//               {/* <select
//                 name="city"
//                 value={selectedCity}
//                 onChange={(e) => {
//                   setSelectedCity(e.target.value);
//                   handleAddressChange("city", e.target.value);
//                 }}
//                 className="input-primary"
//                 disabled={!selectedState}
//               >
//                 <option value="">Select City</option>
//                 {selectedState &&
//                   stateCityData[selectedState].map((city) => (
//                     <option key={city} value={city}>
//                       {city}
//                     </option>
//                   ))}
//               </select> */}

//               <div className="gap-4">
//                 {/* State Dropdown */}
//                 <div className="relative w-full">
//                   <div
//                     className={`flex items-center justify-between rounded-full border border-gray-300 px-4 py-2 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""
//                       }`}
//                     onClick={() => setStateOpen(!stateOpen)}
//                   >
//                     <span className="text-sm text-gray-700">
//                       {selectedState || "Select State"}
//                     </span>
//                     <MdKeyboardArrowDown className="text-base text-gray-500" />
//                   </div>

//                   {stateOpen && (
//                     <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
//                       {Object.keys(stateCityData).map((state, index) => (
//                         <div
//                           key={state}
//                           className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== Object.keys(stateCityData).length - 1
//                             ? "border-b border-gray-200"
//                             : ""
//                             }`}
//                           onClick={() => {
//                             setSelectedState(state); 
//                             setSelectedCity(""); 
//                             setStateOpen(false);

//                             //trigger form validation update
//                             if (typeof handleStateChange === "function") {
//                               handleStateChange({ target: { name: "state", value: state } });
//                             }
//                           }}
//                         >
//                           {state}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>

//                 {/* City Dropdown */}
//                 <div className="py-2 relative w-full">
//                   <div
//                     className={`flex items-center justify-between rounded-full border px-4 py-2 ${selectedState
//                       ? "bg-white border-gray-300 cursor-pointer"
//                       : "bg-gray-100 border-gray-200 cursor-not-allowed"
//                       } ${cityOpen ? "shadow-md" : ""}`}
//                     onClick={() => selectedState && setCityOpen(!cityOpen)}
//                   >
//                     <span className="text-sm text-gray-700">
//                       {selectedCity || "Select City"}
//                     </span>
//                     <MdKeyboardArrowDown className="text-base text-gray-500" />
//                   </div>

//                   {cityOpen && selectedState && (
//                     <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
//                       {stateCityData[selectedState].map((city, index) => (
//                         <div
//                           key={city}
//                           className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== stateCityData[selectedState].length - 1
//                             ? "border-b border-gray-200"
//                             : ""
//                             }`}
//                           onClick={() => {
//                             setSelectedCity(city);
//                             setCityOpen(false);

//                             //  trigger form validation update
//                             if (typeof handleCityChange === "function") {
//                               handleCityChange({ target: { name: "city", value: city } });
//                             }
//                           }}
//                         >
//                           {city}
//                         </div>
//                       ))}
//                     </div>
//                   )}
//                 </div>
//               </div>

//               <CustomSelect
//                 dataArray={["Home", "Office", "Other"]}
//                 onSelect={handleAddressTypeSelect}
//                 selectedItem={addAddress.type}
//               />
//             </div>
//           </div>
//         )}

//         {!isAddingAddress && addressData?.length > 0 && (
//           <div className="w-full h-[75%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
//             {addressData?.map((address, index) => (
//               <div
//                 className="w-full h-fit bg-white flex flex-col justify-start items-start border border-accentColor rounded-2xl p-[5%] cursor-pointer hover:border-2"
//                 key={index}
//                 onClick={() => updateAddress(address)}
//               >
//                 <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//                   {address.house}, {address.area}, {address.city},{" "}
//                   {address.state} - {address.pincode}
//                 </span>
//               </div>
//             ))}
//           </div>
//         )}

//         {!isAddingAddress && addressData?.length === 0 && (
//           <div className="w-full h-[75%] flex justify-center items-center">
//             <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
//               No address added yet
//             </p>
//           </div>
//         )}

//         {isAddingAddress ? (
//           <button
//             className="btn-primary"
//             onClick={() => {
//               addressSave(addAddress);
//               handleAddingAddress();
//             }}
//           >
//             Save Address
//           </button>
//         ) : (
//           <button className="btn-primary" onClick={handleAddingAddress}>
//             Add Address
//           </button>
//         )}
//       </div>
//     </div>
//   );
// };

// export default AddAddressPopup;




import React, { useState, useEffect } from "react";
import { MdClose, MdArrowBackIos, MdKeyboardArrowDown } from "../utils/Icons";
import { useAddressContext } from "../context/AddressContext";
import { useOrderProcessingContext } from "../context/OrderProcessingContext";
import CustomInput from "../components/CustomComponents/CustomInput";
import CustomSelect from "../components/CustomComponents/CustomSelect";
export const baseUrl = "http://localhost:5000";
const AddAddressPopup = ({ closeButton }) => {
  const { addressData, addressSave, addAddress, setAddAddress } = useAddressContext();
  const { updateAddress } = useOrderProcessingContext();

  const [isAddingAddress, setIsAddingAddress] = useState(false);
  const [selectedCity, setSelectedCity] = useState("");
  const [selectedState, setSelectedState] = useState("");
  const [stateOpen, setStateOpen] = useState(false);
  const [cityOpen, setCityOpen] = useState(false);
  const [isFormValid, setIsFormValid] = useState(false);



  const handleAddressChange = (name, value) => {
    setAddAddress((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRestOfAddress = (e) => {
    const { name, value } = e.target;
    handleAddressChange(name, value);
  };


  const handleStateSelect = (state) => {
    setSelectedState(state);
    setSelectedCity("");
    handleAddressChange("state", state); //ensures addAddress.state is updated
    handleAddressChange("city", "");     // reset city too
    setStateOpen(false);
  };


  const handleCitySelect = (city) => {
    setSelectedCity(city);
    handleAddressChange("city", city);
    setCityOpen(false);
  };

  const handleAddressTypeSelect = (type) => {
    handleAddressChange("type", type);
  };

  const handleAddingAddress = () => {
    setIsAddingAddress((prev) => !prev);
  

    // reset dropdowns when form is closed or reopened
    setSelectedState("");
    setSelectedCity("");
    setCityList([]);
    setStateOpen(false);
    setCityOpen(false);

    // also clear other form fields if needed
    setAddAddress({
      house: "",
      area: "",
      pincode: "",
      state: "",
      city: "",
      type: ""
    });
  };

  //  Validate form fields
  useEffect(() => {
    const { house, area, pincode, state, city, type } = addAddress;
    const isValid =
      house?.trim() &&
      area?.trim() &&
      pincode?.toString().length === 6 &&
      state?.trim() &&
      city?.trim() &&
      type?.trim();
    setIsFormValid(!!isValid);
  }, [addAddress]);

  const fetchState = {
    'Andhra Pradesh': ["Visakhapatnam", "Vijayawada", "Tirupati"],
    'Arunachal Pradesh': ["Itanagar", "Naharlagun", "Bomdila"],
    Assam: ["Guwahati", "Dibrugarh", "Silchar"],
    Bihar: ["Patna", "Gaya", "Muzaffarpur"],
    Chhattisgarh: ["Raipur", "Bilaspur", "Durg"],
    Goa: ["Panaji", "Margao", "Vasco da Gama"],
    Gujarat: ["Ahmedabad", "Surat", "Vadodara"],
    Haryana: ["Gurgaon", "Faridabad", "Panchkula"],
    "Himachal Pradesh": ["Shimla", "Manali", "Dharamshala"],
    Jharkhand: ["Ranchi", "Jamshedpur", "Dhanbad"],
    Karnataka: ["Bengaluru", "Mysuru", "Mangaluru"],
    Kerala: ["Thiruvananthapuram", "Kochi", "Kozhikode"],
    'Madhya Pradesh': ["Bhopal", "Indore", "Jabalpur"],
    Maharashtra: ["Mumbai", "Pune", "Nagpur"],
    Manipur: ["Imphal", "Thoubal", "Bishnupur"],
    Meghalaya: ["Shillong", "Tura", "Jowai"],
    Mizoram: ["Aizawl", "Lunglei", "Saiha"],
    Nagaland: ["Kohima", "Dimapur", "Mokokchung"],
    Odisha: ["Bhubaneswar", "Cuttack", "Rourkela"],
    Punjab: ["Chandigarh", "Amritsar", "Ludhiana"],
    Rajasthan: ["Jaipur", "Jodhpur", "Udaipur"],
    Sikkim: ["Gangtok", "Namchi", "Pelling"],
    "Tamil Nadu": ["Chennai", "Coimbatore", "Madurai"],
    Telangana: ["Hyderabad", "Warangal", "Nizamabad"],
    Tripura: ["Agartala", "Udaipur", "Dharmanagar"],
    "Uttar Pradesh": ["Lucknow", "Kanpur", "Varanasi"],
    Uttarakhand: ["Dehradun", "Haridwar", "Rishikesh"],
    "West Bengal": ["Kolkata", "Howrah", "Siliguri"],
    'Andaman and Nicobar Islands': ["Port Blair", "Diglipur"],
    Chandigarh: ["Chandigarh"],
    'Dadra and Nagar Haveli and Daman and Diu': ["Daman", "Silvassa"],
    Delhi: ["New Delhi", "Dwarka", "Rohini"],
    'Jammu and Kashmir': ["Srinagar", "Jammu", "Anantnag"],
    Ladakh: ["Leh", "Kargil"],
    Lakshadweep: ["Kavaratti", "Agatti"],
    Puducherry: ["Puducherry", "Karaikal"],
  }

  const [cityList, setCityList] = useState([]);
  const [loadingCities, setLoadingCities] = useState(false);
  
  useEffect(() => {
    const fetchCities = async () => {
      if (!selectedState) return;

      setLoadingCities(true);
      try {
        const response = await fetch(
          // `http://localhost:5000/api/stateAndCity/getStateAndCity/${selectedState}`
          `${baseUrl}/api/stateAndCity/getStateAndCity/${selectedState}`
        );
        const data = await response.json();
        // console.log("Fetched districts:", data.districts); // check the array
        setCityList(data.districts || []); // <-- use the array
      } catch (error) {
        console.error("Failed to fetch districts:", error);
        setCityList([]);
      }
      setLoadingCities(false);
    };

    fetchCities();
  }, [selectedState]);


  return (
    <div className="w-screen h-screen bg-black/25 backdrop-blur flex justify-center items-center p-[2%] fixed left-0 top-0 right-0 bottom-0 z-50">
      <div className="w-full lg:w-[25%] h-full lg:h-[75%] bg-whiteColor flex flex-col justify-start items-center rounded-3xl lg:rounded-3xl p-[2%] lg:p-[1%]">
        <div className="w-full h-fit flex justify-end items-center">
          <button
            className="text-[5vw] lg:text-[1.25vw] text-textPrimaryColor"
            onClick={closeButton}
          >
            <MdClose />
          </button>
        </div>
        <span className="font-semibold text-[5vw] lg:text-[1.25vw] text-textPrimaryColor mb-[1%]">
          Select Address
        </span>

        {isAddingAddress && (
          <div className="w-full h-[79%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden scrollbar-hide">
            <div className="w-full h-fit space-y-[3%]">
              <button
                className="flex items-center font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor"
                onClick={handleAddingAddress}
              >
                <MdArrowBackIos className="text-[5vw] lg:text-[1.5vw]" />
                <span>Back</span>
              </button>
              <CustomInput
                type="text"
                name="house"
                placeholder="House No."
                value={addAddress.house}
                onChange={handleRestOfAddress}
              />
              <CustomInput
                type="text"
                name="area"
                placeholder="Area"
                value={addAddress.area}
                onChange={handleRestOfAddress}
              />

              <input
                type="number"
                id="pincode"
                name="pincode"
                placeholder="Pincode"
                value={addAddress.pincode}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value.length <= 6) {
                    handleRestOfAddress(e);
                  }
                }}
                max={999999}
                className="input-primary"
              />

              {/* State Dropdown */}
              {/* <div className="relative w-full">
                <div
                  className={`flex items-center justify-between rounded-full border border-gray-300 px-4 py-2 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""}`}
                  onClick={() => setStateOpen(!stateOpen)}
                >
                  <span className="text-sm text-gray-700">
                    {selectedState || "Select State"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {stateOpen && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                    {Object.keys(stateCityData).map((state, index) => (
                      <div
                        key={state}
                        className={`px-4 py-3 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 ${
                          index !== Object.keys(stateCityData).length - 1
                            ? "border-b border-gray-200"
                            : ""
                        }`}
                        onClick={() => handleStateSelect(state)}
                      >
                        {state}
                      </div>
                    ))}
                  </div>
                )}
              </div> */}

              {/* City Dropdown */}
              {/* <div className="relative w-full">
                <div
                  className={`flex items-center justify-between rounded-full border px-4 py-2 ${
                    selectedState
                      ? "bg-white border-gray-300 cursor-pointer"
                      : "bg-gray-100 border-gray-200 cursor-not-allowed"
                  } ${cityOpen ? "shadow-md" : ""}`}
                  onClick={() => selectedState && setCityOpen(!cityOpen)}
                >
                  <span className="text-sm text-gray-700">
                    {selectedCity || "Select City"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {cityOpen && selectedState && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                    {stateCityData[selectedState].map((city, index) => (
                      <div
                        key={city}
                        className={`px-4 py-3 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 ${
                          index !== stateCityData[selectedState].length - 1
                            ? "border-b border-gray-200"
                            : ""
                        }`}
                        onClick={() => handleCitySelect(city)}
                      >
                        {city}
                      </div>
                    ))}
                  </div>
                )}
              </div> */}

              {/* State Dropdown */}
              {/* <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between ${stateOpen ? "shadow-md" : ""
                    }`}
                  onClick={() => setStateOpen(!stateOpen)}
                >
                  <span className="text-sm text-gray-700">
                    {selectedState || "Select State"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {stateOpen && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                    {Object.keys(stateCityData).map((state, index) => (
                      <div
                        key={state}
                        className={`px-4 py-3 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 ${index !== Object.keys(stateCityData).length - 1
                            ? "border-b border-gray-200"
                            : ""
                          }`}
                        onClick={() => handleStateSelect(state)}
                      >
                        {state}
                      </div>
                    ))}
                  </div>
                )}
              </div> */}

              {/* City Dropdown */}
              {/* <div className="relative w-full">
                <div
                  className={`dropdown-box flex items-center justify-between ${selectedState
                      ? "bg-white border-gray-300"
                      : "bg-gray-100 border-gray-200 cursor-not-allowed"
                    } ${cityOpen ? "shadow-md" : ""}`}
                  onClick={() => selectedState && setCityOpen(!cityOpen)}
                >
                  <span className="text-sm text-gray-700">
                    {selectedCity || "Select City"}
                  </span>
                  <MdKeyboardArrowDown className="text-base text-gray-500" />
                </div>

                {cityOpen && selectedState && (
                  <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                    {stateCityData[selectedState].map((city, index) => (
                      <div
                        key={city}
                        className={`px-4 py-3 text-sm text-gray-700 cursor-pointer hover:bg-gray-100 ${index !== stateCityData[selectedState].length - 1
                            ? "border-b border-gray-200"
                            : ""
                          }`}
                        onClick={() => handleCitySelect(city)}
                      >
                        {city}
                      </div>
                    ))}
                  </div>
                )}
              </div> */}




              {/* --------------dynamic state dropdown ----------------- */}
              {/* <div className="flex gap-8">
                <div className="relative w-full">
                  <div
                    className={`dropdown-box flex items-center justify-between rounded-full border border-gray-300 px-4 py-1.5 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""}`}
                    onClick={() => setStateOpen(!stateOpen)}
                  >
                    <span className="text-sm md:text-4xl lg:text-sm text-gray-700">
                      {selectedState || "Select State"}
                    </span>
                    <MdKeyboardArrowDown className="text-base text-gray-500" />
                  </div>

                  {stateOpen && (
                    <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
               
                      {Object.keys(fetchState).map((state, index, arr) => (
                        <div
                          key={state}
                          className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== arr.length - 1 ? "border-b border-gray-200" : ""
                            }`}
                          onClick={() => {
                            setSelectedState(state); 
                            setSelectedCity(""); 
                            setStateOpen(false);
                          }}
                        >
                          {state}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div> */}
              {/* --------------------dynamic state dropdown with api update part 2----------------- */}
              <div className="flex gap-8">
                {/* State Dropdown */}
                <div className="relative w-full">
                  <div
                    className={`dropdown-box flex items-center justify-between rounded-full border border-gray-300 px-4 py-1.5 cursor-pointer bg-white ${stateOpen ? "shadow-md" : ""}`}
                    onClick={() => setStateOpen(!stateOpen)}
                  >
                    <span className="text-sm md:text-4xl lg:text-sm text-gray-700">
                      {selectedState || "Select State"}
                    </span>
                    <MdKeyboardArrowDown className="text-base text-gray-500" />
                  </div>

                  {stateOpen && (
                    <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden">
                      {Object.keys(fetchState).map((state, index, arr) => (
                        <div
                          key={state}
                          className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== arr.length - 1 ? "border-b border-gray-200" : ""
                            } hover:bg-gray-100`}
                          onClick={() => handleStateSelect(state)}
                        >
                          {state}
                        </div>
                      ))}
                    </div>
                  )}
                </div>
              </div>


              {/* -------------update city dropdown with api */}

              {/* <div className="flex gap-8">
                <div className="relative w-full">
                  <div
                    className={`dropdown-box flex items-center justify-between rounded-full border px-4 py-2 ${selectedState
                      ? "bg-white border-gray-300 cursor-pointer"
                      : "bg-gray-100 border-gray-200 cursor-not-allowed"
                      } ${cityOpen ? "shadow-md" : ""}`}
                    onClick={() => selectedState && setCityOpen(!cityOpen)}
                  >
                    <span className="text-sm md:text-4xl lg:text-sm text-gray-700">
                      {selectedCity || "Select City"}
                    </span>
                    <MdKeyboardArrowDown className="text-base text-gray-500" />
                  </div>

                  {cityOpen && selectedState && (
                    <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden max-h-60 overflow-y-auto">
                      {cityList.length > 0 ? (
                        cityList.map((city, index) => (
                          <div
                            key={city}
                            className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== cityList.length - 1 ? "border-b border-gray-200" : ""
                              } hover:bg-gray-100`}
                            onClick={() => {
                              setSelectedCity(city);
                              setCityOpen(false);
                            }}
                          >
                            {city}
                          </div>
                        ))
                      ) : (
                        <div className="px-4 py-2 text-sm text-gray-400">Loading cities...</div>
                      )}
                    </div>
                  )}
                </div>

              </div> */}
              {/* ------------------dynamical city dropdown update part 2---------------- */}
              <div className="flex gap-8">
                {/* City Dropdown */}
                <div className="relative w-full">
                  <div
                    className={`dropdown-box flex items-center justify-between rounded-full border px-4 py-2 ${selectedState
                      ? "bg-white border-gray-300 cursor-pointer"
                      : "bg-gray-100 border-gray-200 cursor-not-allowed"
                      } ${cityOpen ? "shadow-md" : ""}`}
                    onClick={() => selectedState && setCityOpen(!cityOpen)}
                  >
                    <span className="text-sm md:text-4xl lg:text-sm text-gray-700">
                      {selectedCity || "Select City"}
                    </span>
                    <MdKeyboardArrowDown className="text-base text-gray-500" />
                  </div>

                  {cityOpen && selectedState && (
                    <div className="absolute mt-1 w-full bg-white border rounded-xl shadow-md z-50 overflow-hidden max-h-60 overflow-y-auto">
                      {cityList.length > 0 ? (
                        cityList.map((city, index) => (
                          <div
                            key={city}
                            className={`px-4 py-2 text-sm text-gray-700 cursor-pointer ${index !== cityList.length - 1 ? "border-b border-gray-200" : ""
                              } hover:bg-gray-100`}
                            onClick={() => handleCitySelect(city)}
                          >
                            {city}
                          </div>
                        ))
                      ) : (
                        <div className="px-4 py-2 text-sm text-gray-400">
                          Loading cities...
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>

              <CustomSelect
                dataArray={["Home", "Office", "Other"]}
                onSelect={handleAddressTypeSelect}
                selectedItem={addAddress.type}
              />
            </div>
          </div>
        )}

        {!isAddingAddress && addressData?.length > 0 && (
          <div className="w-full h-[75%] flex flex-col justify-start items-center border-b px-[5%] space-y-[3%] mb-[2%] overflow-x-hidden overflow-y-scroll scrollbar-hide">
            {addressData?.map((address, index) => (
              <div
                className="w-full h-fit bg-white flex flex-col justify-start items-start border border-accentColor rounded-2xl p-[5%] cursor-pointer hover:border-2"
                key={index}
                onClick={() => updateAddress(address)}
              >
                <span className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
                  {address.house}, {address.area}, {address.city},{" "}
                  {address.state} - {address.pincode}
                </span>
              </div>
            ))}
          </div>
        )}

        {!isAddingAddress && addressData?.length === 0 && (
          <div className="w-full h-[75%] flex justify-center items-center">
            <p className="font-normal text-[4vw] lg:text-[1vw] text-textPrimaryColor">
              No address added yet
            </p>
          </div>
        )}

        {isAddingAddress ? (
          <button
            className={`btn-primary ${!isFormValid ? "opacity-50 cursor-not-allowed" : ""}`}
            disabled={!isFormValid}
            onClick={() => {
              addressSave(addAddress);
              handleAddingAddress();
            }}
          >
            Save Address
          </button>
        ) : (
          <button className="btn-primary" onClick={handleAddingAddress}>
            Add Address
          </button>
        )}
      </div>
    </div>
  );
};

export default AddAddressPopup;
